/* eslint-disable */
import React, { PureComponent } from 'react'

import { currencyMaker } from 'services/helpers'

const tableCellStyles = {
  border: '1px solid #e0e0e0',
  padding: '3px',
  position: 'relative',
}

const smallTextStyles = {
  opacity: .9
}

const logoImg = {
  height: 40,
  padding: 3
}

const phonesContainer = {
  display: 'inline-block',
  textAlign: 'left'
}

const icon = {
  height: 15,
  margin: '0 5px -2px'
}

export class Ticket extends PureComponent {
  createdDate = this.props.data.createdDate.split(' ')[0]

  tableStyles = {
    width: '210mm',
    height: '300px',
    fontSize: 12,
    marginTop: this.props.index === 0 ? 0 : 65,
    textAlign: 'center',
    borderCollapse: 'collapse',
    backgroundImage: this.props.isPrexBus ? `url('https://firebasestorage.googleapis.com/v0/b/prex-6d36c.appspot.com/o/imgs%2Flogo_bg.png?alt=media&token=6bfa1a04-a8fb-4ba4-89ff-04c3116b0eaa')` : '',
    backgroundPosition: 'center',
    backgroundSize: '100%',
    backgroundRepeat: 'no-repeat'
  }

  render() {
    const { data, isPrexBus } = this.props

    return (
      <table style={this.tableStyles}>
        {isPrexBus && (
          <thead>
            <tr>
              <td colSpan='2'>
                <img
                  style={logoImg}
                  src='https://firebasestorage.googleapis.com/v0/b/prex-6d36c.appspot.com/o/imgs%2Fjanosik-logo.png?alt=media&token=e4b2384a-8948-4439-b1fd-2f3e7aad4be8'
                  alt='Janosik text'
                />
              </td>
              <td colSpan='2'>
                <img
                  style={logoImg}
                  src='https://firebasestorage.googleapis.com/v0/b/prex-6d36c.appspot.com/o/imgs%2Flogo.png?alt=media&token=2d805a5f-1e24-4a8f-932f-62794e722032'
                  alt='Prex text'
                />
              </td>
            </tr>
          </thead>
        )}
        <tbody>
          <tr>
            <td style={tableCellStyles}>
              <small style={smallTextStyles}>
                Місце продажу / Miejsce sprzedaży / Sale place
              </small>
              <br />
              м. Коломия, вул. Майданського 12/1
            </td>
            <td colSpan='2' style={tableCellStyles}>
              <small style={smallTextStyles}>
                Дата видачі / Data wydania / Release date
              </small>
              <br />
              {this.createdDate}
            </td>
            <td style={tableCellStyles}>
              <small style={smallTextStyles}>
                № квитка
              </small>
              <br />
              {data.id}
            </td>
          </tr>
          <tr>
            <td style={tableCellStyles}>
              <small style={smallTextStyles}>
                Агент/Agent/Agent
              </small>
              <br />
              {data.sourceId === "new_website" ? "prex.com.ua" : data.userName}
            </td>
            <td colSpan='2' style={tableCellStyles}>
              <small style={smallTextStyles}>
                Детальна інформація / Szczegółowe informacje / Detail information
              </small>
              <br />
              <strong>www.prex.com.ua</strong>
            </td>
            <td style={tableCellStyles}>
              <small style={smallTextStyles}>
                Відшкодуванн/Wypłata ubezpieczeniowa/Insurance Payment
              </small>
              <br />
              <strong>до 102 000 грн.</strong>
            </td>
          </tr>
          <tr>
            <td style={tableCellStyles}>
              <small style={smallTextStyles}>Рейс / Droga / Route</small>
              <br />
              <strong>{data.routeName}</strong>
            </td>
            <td colSpan='2' style={tableCellStyles}>
              <small style={smallTextStyles}>
                Місце відправлення, Платформа / Miejsce wyjazdu, Stanowisko / Departure place, Platform
              </small>
              <br />
              <strong>{data.departurePlace}</strong>
            </td>
            <td rowSpan='2' style={tableCellStyles}>
              <small style={smallTextStyles}>
                Штамп / Pieczątka / Stamp
              </small>
            </td>
          </tr>
          <tr>
            <td style={tableCellStyles}>
              <small style={smallTextStyles}>
                Маршрут / Podróż / Trip
              </small>
              <br />
              <strong>{data.from} - {data.to}</strong>
            </td>
            <td style={tableCellStyles}>
              <small style={smallTextStyles}>
                Дата / Data / Date
              </small>
              <br />
              <strong>
                {data.ticketDepartureDate ? data.ticketDepartureDate : data.departureDate}
              </strong>
            </td>
            <td style={tableCellStyles}>
              <small style={smallTextStyles}>
                Година / Godzina / Time
              </small>
              <br />
              <strong>{data.departureTime}</strong>
            </td>
          </tr>
          <tr>
            <td style={tableCellStyles}>
              <small style={smallTextStyles}>
                Ім’я, Прізвище / Іmię, Nazwisko / Firstname, Lastname
              </small>
              <br />
              <strong>{data.name} {data.surname}</strong>
            </td>
            <td style={tableCellStyles}>
              <small style={smallTextStyles}>
                Місце / Miejsce / Seat
              </small>
              <br />
              <strong>-</strong>
              <br />
              <small style={smallTextStyles}>
                (вказується при посадці)
              </small>
            </td>
            <td style={tableCellStyles}>
              <small style={smallTextStyles}>
                Багаж / Bagaż / Luggage
              </small>
              <br />
              <strong>-</strong>
              <br />
              <small style={smallTextStyles}>
                (до 2 одиниць)
              </small>
            </td>
            <td style={tableCellStyles}>
              <small style={smallTextStyles}>
                Вартість / Cena / Сost
              </small>
              <br />
              <strong>{data.price} {currencyMaker(
                this.props.fromCityTypeByLabel,
                this.props.data.price,
                this.props.data.sourceId
              )}</strong>
              <br />
            </td>
          </tr>
        </tbody>
        {isPrexBus && (
          <tfoot>
            <tr>
              <td colSpan='2'>
                Даний документ є підставою для проїзду без звернення у касу
              <br />
                Ten dokument jest powodem podróży bez ubiegania się do kasy
              <br />
                This document is the reason for travel without the cash desk apply
              <br />
              </td>
              <td>
                <div style={phonesContainer}>
                  <img
                    style={icon}
                    src='https://firebasestorage.googleapis.com/v0/b/prex-6d36c.appspot.com/o/imgs%2Fmisc%2Fvodafon_logo.png?alt=media&token=8a2f4c83-cc3b-4901-93d8-266014558acd'
                    alt=''
                  />
                  +38 099 1200 900
                <br />
                  <img
                    style={icon}
                    src='https://firebasestorage.googleapis.com/v0/b/prex-6d36c.appspot.com/o/imgs%2Fmisc%2Flifecell_logo.png?alt=media&token=7b7ff52e-e23f-4809-9893-f9e96a6a191e'
                    alt=''
                  />
                  +38 063 1200 900
                <br />
                  <img
                    style={icon}
                    src='https://firebasestorage.googleapis.com/v0/b/prex-6d36c.appspot.com/o/imgs%2Fmisc%2Fkyivstar_logo.png?alt=media&token=75292c73-8047-4c40-a46c-712c5eefcfee'
                    alt=''
                  />
                  +38 096 1200 900
              </div>

                <div style={phonesContainer}>
                  <img
                    style={icon}
                    src='https://firebasestorage.googleapis.com/v0/b/prex-6d36c.appspot.com/o/imgs%2Fmisc%2Fpoland_flag_icon.png?alt=media&token=41ce86f3-6bf2-4bd9-a94e-6649191fa6f9'
                    alt=''
                  />
                  +48 222 922 928
                <br />
                  <img
                    style={icon}
                    src='https://firebasestorage.googleapis.com/v0/b/prex-6d36c.appspot.com/o/imgs%2Fmisc%2Fch_flag_icon.png?alt=media&token=d29f4cd7-29c3-46d8-b5b5-aa04facb699e'
                    alt=''
                  />
                  +420 22 888 1504
                <br />
                  <img
                    style={icon}
                    src='https://firebasestorage.googleapis.com/v0/b/prex-6d36c.appspot.com/o/imgs%2Fmisc%2Farrow_socials.png?alt=media&token=6b29a107-a91c-4047-8075-f5b99e51c386'
                    alt=''
                  />
                </div>
              </td>
              <td>
                <img
                  style={{ height: 60 }}
                  src='https://firebasestorage.googleapis.com/v0/b/prex-6d36c.appspot.com/o/imgs%2Fmisc%2Fticket_qr.png?alt=media&token=078ded3e-73f7-442d-afdb-51a40f969135'
                  alt='QR-code'
                />
              </td>
            </tr>
          </tfoot>
        )}
      </table>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Ticket/Ticket.js